import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import bemClassName from '../../utils/bem';
import './index.scss';
import Icon from '../../UI/Icon';
import MessageData from '../../API/MessageData';
import Loading from '../../UI/Loading';
import formatedDateOfStay from '../../utils/historyBookingsUtils';
import mediaConverter from '../../utils/mediaConverter';

const chat = bemClassName('chat');

const Chat = ({ chat_id }: { chat_id: string }) => {
  const [chatData, setChatData] = useState<any>();
  const [messages, setMessages] = useState<{ text: string; mine?: boolean; files?: File[] }[]>([]);
  const [lastMessageId, setLastMessageId] = useState<number>();
  const [inputValue, setInputValue] = useState('');

  const [files, setFiles] = useState<FileList | undefined>(undefined);
  const [responseFile, setResponseFile] = useState<any>();

  const [firstRequest, setFirstRequest] = useState<boolean>(false);
  const [isLoadingChat, setIsLoadingChat] = useState<boolean>(false);
  const [reachedTop, setReachedTop] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const messagesEndRef = useRef<HTMLDivElement>(null);

  const [containerHeight, setContainerHeight] = useState<number>(0);

  let parsedHTML: any;

  const parsingFile = (text: any) => {
    if (text !== '') {
      parsedHTML = parse(text);
    }
    return parsedHTML;
  };

  const handleMessageSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (inputValue.trim() !== '') {
      setMessages([...messages, { text: inputValue, mine: true }]);
      setInputValue('');
      setFiles(undefined);
      if (chat_id) {
        MessageData.postAddedMessage(chat_id, inputValue, responseFile)
          .then((item) => {
            setLastMessageId(item.id);
          })
          .catch((sendError) => {
            const messageSendErrorHtml = `<span class=${chat(
              'error',
            )}>Не удалось отправить сообщение: ${sendError}</span>`;
            setMessages([...messages, { text: messageSendErrorHtml, mine: true }]);
          });
      }
    }
  };

  const handleFileSubmit = () => {
    if (files && files.length > 0) {
      const filesArray = Array.from(files);
      setMessages([...messages, { text: '', mine: true, files: filesArray }]);
      const uploadPromises = filesArray.map((file) =>
        MessageData.postAddedMedia(file).catch((uploadError) => {
          console.error(`Ошибка при загрузке файла "${file.name}":`, uploadError.message);
          const errorMessageWithHtml = `<span class=${chat('error')}>${uploadError.message}</span>`;
          setMessages([...messages, { text: errorMessageWithHtml, mine: true }]);
          return null;
        }),
      );
      Promise.all(uploadPromises).then((results) => {
        const successfullyUploaded = results.filter((item) => item !== null);
        setResponseFile(successfullyUploaded);
        if (successfullyUploaded.length > 0 && chat_id) {
          MessageData.postAddedMessage(chat_id, inputValue, successfullyUploaded)
            .then((item2) => {
              setLastMessageId(item2.id);
            })
            .catch((sendError) => {
              const messageSendErrorHtml = `<span class=${chat(
                'error',
              )}>Не удалось отправить сообщение: ${sendError.message}</span>`;
              setMessages([...messages, { text: messageSendErrorHtml, mine: true }]);
            });
        }
      });
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFiles(event.target.files);
    }
  };

  const handlerScrollTo = () => {
    // if (messagesEndRef && messagesEndRef.current) {
    //   messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    // }
    if (messagesEndRef && messagesEndRef.current) {
      const newScrollTop = messagesEndRef.current.scrollHeight - containerHeight;
      messagesEndRef.current.scrollTop = newScrollTop > 0 ? newScrollTop : 0;
    }
  };

  const handleScrollMaxTop = () => {
    if (messagesEndRef.current) {
      const { scrollTop } = messagesEndRef.current;
      if (scrollTop === 0 && !reachedTop) {
        setReachedTop(true);
      }
    }
  };

  const newMessage = async () => {
    if (chat_id && lastMessageId) {
      try {
        const item = await MessageData.getNewMessages(chat_id, lastMessageId);
        if (item) {
          const result: any = Object.values(item);
          if (result.length > 0) {
            const newMessagesToAppend: (typeof messages)[0][] = [];
            await Promise.all(
              result.map(async (items: any) => {
                let filesArray: File[] = [];
                if (items.media && items.media.length > 0) {
                  filesArray = await mediaConverter(items.media);
                }
                newMessagesToAppend.push({
                  text: items.message,
                  mine: !items.incoming, // Если incoming true, то mine будет false
                  files: filesArray,
                });
              }),
            );
            if (newMessagesToAppend.length > 0) {
              setMessages((prevMessages) => [...prevMessages, ...newMessagesToAppend]);
              const lastItem = result[result.length - 1];
              if (lastItem && lastItem.id) {
                setLastMessageId(lastItem.id);
              }
            }
          }
        }
      } catch (error) {
        if (typeof error === 'object' && error !== null && 'name' in error) {
          if (error.name !== 'AbortError') {
            console.error('Ошибка при загрузке новых сообщений:', error);
          }
        } else {
          console.error('Неизвестная ошибка:', error);
        }
      }
    }
  };

  useEffect(() => {
    handleFileSubmit();
  }, [files]);

  useEffect(() => {
    handlerScrollTo();
  }, [messages, containerHeight]);

  useEffect(() => {
    const loadOlderMessages = async () => {
      if (chat_id && reachedTop) {
        const abortControllerOldMessages = new AbortController();
        setIsLoadingChat(true);
        const container = messagesEndRef.current;
        try {
          const response = await MessageData.getMessageDataСhat({
            id: chat_id,
            offset: messages.length,
            signal: abortControllerOldMessages.signal,
          });
          if (container) {
            setContainerHeight(container.scrollHeight);
          }
          const items = response.messages?.data;
          if (items && items.length > 0) {
            const newMessagesToPrepend: (typeof messages)[0][] = [];
            items.forEach(async (item: any) => {
              let filesArray: File[] = [];
              if (item.media && item.media.length > 0) {
                filesArray = await mediaConverter(item.media);
              }
              newMessagesToPrepend.push({
                text: item.message,
                mine: !item.incoming, // Если incoming === true, то mine будет false
                files: filesArray,
              });
            });
            if (newMessagesToPrepend.length > 0) {
              setMessages((prevMessages) => [
                ...newMessagesToPrepend, // Новые сообщения добавляем в начало
                ...prevMessages,
              ]);
            }
          }
        } catch (error) {
          if (typeof error === 'object' && error !== null && 'name' in error) {
            if (error.name !== 'AbortError') {
              console.error('Ошибка при загрузке старых сообщений:', error);
            }
          } else {
            console.error('Неизвестная ошибка:', error);
          }
        } finally {
          setIsLoadingChat(false);
          setReachedTop(false);
        }
      }
    };
    loadOlderMessages();
  }, [reachedTop, chat_id, messages]);

  useEffect(() => {
    newMessage();
    const interval = setInterval(newMessage, 5000);

    return () => clearInterval(interval);
  }, [lastMessageId, chat_id]);

  useEffect(() => {
    setFirstRequest(true);
    setIsLoading(true);
    const fetchInitialData = async () => {
      if (chat_id) {
        try {
          const item = await MessageData.getMessageDataСhat({ id: chat_id });
          setIsLoading(false);
          if (item?.messages?.data?.length > 0) {
            setChatData(item);
            const result = item.messages.data;
            const newMessages = await Promise.all(
              result.map(async (items: any) => {
                let filesArray: File[] = [];
                if (items.media && items.media.length > 0) {
                  filesArray = await mediaConverter(items.media);
                }
                return {
                  text: items.message,
                  mine: !items.incoming, // Если incoming true, то mine будет false
                  files: filesArray,
                };
              }),
            );
            const validMessages = newMessages.filter(
              (msg): msg is ReturnType<typeof result.map>[0] => msg !== null,
            );
            if (validMessages.length > 0) {
              setMessages(validMessages);
              setLastMessageId(result[result.length - 1].id);
            }
          }
        } catch (error) {
          setIsLoading(false);
          if (typeof error === 'object' && error !== null && 'name' in error) {
            if (error.name !== 'AbortError') {
              console.error('Ошибка при загрузке старых сообщений:', error);
            }
          } else {
            console.error('Неизвестная ошибка:', error);
          }
        }
      }
    };
    fetchInitialData();
  }, [chat_id, firstRequest]);

  return !isLoading ? (
    <div className={chat()}>
      {chatData && (
        <Link to="/account#messages" className={chat('item')}>
          <Icon externalClassName={chat('back')} iconName="back_chat" />
          {chatData.photos && (
            <picture className={chat('picture')}>
              <img
                className={chat('image')}
                src={`${chatData.photos?.['298x298'][0]}`}
                srcSet={`${chatData.photos?.['596x596'][0]} 2x, ${chatData.photos?.['894x894'][0]} 3x`}
                alt=""
              />
            </picture>
          )}
          <div className={chat('preview')}>
            <h4 className={chat('preview-title')}>
              <span className={chat('preview-title-text')}>{chatData.title}</span>
              <span className={chat('preview-title-info')}>
                <span className={chat('separator')} />
                <span className={chat('description')}>{chatData.city}</span>
                <span className={chat('separator')} />
                {chatData.dates === null ? undefined : (
                  <span className={chat('description')}>
                    {formatedDateOfStay(chatData.created_at, chatData.updated_at)}
                  </span>
                )}
              </span>
            </h4>
          </div>
        </Link>
      )}
      <div onScroll={handleScrollMaxTop} ref={messagesEndRef} className={chat('messages')}>
        {isLoadingChat && (
          <Loading
            externalClassName={chat('loading-message', {
              firstrender: !chatData,
            })}
          />
        )}
        {messages.map((message, index) => (
          <div key={index} className={chat('message', { mine: message.mine })}>
            {message.text && parsingFile(message.text)}
            {message.files?.map((file, fileIndex) => (
              <div key={fileIndex} className={chat('media-file')}>
                {(() => {
                  const isSingleFile = fileIndex < 1;
                  const fileClass = isSingleFile ? 'media-single-img' : 'media-img';
                  return (
                    <div>
                      {file.type.startsWith('image/') ? (
                        <img
                          className={chat(fileClass)}
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                        />
                      ) : (
                        <a href={URL.createObjectURL(file)} download={file.name}>
                          {file.name}
                        </a>
                      )}
                    </div>
                  );
                })()}
              </div>
            ))}
          </div>
        ))}
      </div>
      <form onSubmit={handleMessageSubmit} className={chat('send-message')}>
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className={chat('write')}
          placeholder="Напишите сообщение..."
        />
        <div className={chat('file')}>
          <label htmlFor="input__file">
            <Icon externalClassName={chat('attach-icon')} iconName="attach" />
            <input
              id="input__file"
              className={chat('file-input')}
              type="file"
              multiple
              onChange={handleFileChange}
            />
          </label>
        </div>
        <button type="submit">
          <Icon externalClassName={chat('send')} iconName="send" />
        </button>
      </form>
    </div>
  ) : (
    <Loading externalClassName={chat('loading')} />
  );
};

export default Chat;
